// ** React Imports
import React from 'react'

// ** MUI Imports
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'
import FormControlLabel from '@mui/material/FormControlLabel'

// ** React Hook Form
import { Controller } from 'react-hook-form'
import PropTypes from 'prop-types'

const SwitchForm = props => {
  // ** Props
  const { label, control, name, errors, className, disabled, fullWidth, placeholder } = props

  return (
    <FormControl fullWidth={fullWidth}>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange } }) => (
          <FormControlLabel
            label={<Typography color='inherit'>{label}</Typography>}
            style={{ width: 'fit-content' }}
            control={
              <Switch
                onChange={onChange}
                checked={value}
                // error={Boolean(errors[name])}
                disabled={disabled}
                className={className}
              />
            }
          />
        )}
      />
    </FormControl>
  )
}

SwitchForm.propTypes = {
  control: PropTypes.func.isRequired, // Required string prop
  errors: PropTypes.func.isRequired, // Optional string prop
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool
}

export default SwitchForm
